module.exports = __webpack_public_path__ + "static/hs-db74d3e1c5fd13f44227920e870bad6d.jpg";